import session from '@/libs/session'
export default {
  isLogin: false,
  profile: {
		userId: '',
		username: '',
		password: '',
		gender: '',
		birthday: '',
		register_time: '',
		last_login_time: '',
		last_login_ip: '',
		user_level_id: '',
		nickname: '',
		mobile: '',
		register_ip: '',
		avatar: '',
		weixin: '',
		type: '',
		doudou: '',
		deposit: '',
		profit_loss_day: '',
		exchange_amount: '',
		top_up: '',
		growth: '',
		experience: '',
		wage: '',
		receivedWage: '',
		email: '',
		status: '',
		description: '',
		address: '',
		allow_login_area1: '',
		allow_login_area2: '',
		allow_login: '',
		question_id: '',
		answer: '',
		bank_password: '',
		card_password: '',
		qq: '',
		isAgent:0,
		cardVerify:1,
		smsVerify:0
  },
  getLetterList: [],
  sendLetterList: [],
  accountRecordList: [],
  complainList: [],
  helpList: [],
  signData:{
	  days: '',
	  sumDoudou: '',
	  totalTimes: '',
	  signManagementVoList: []
  },
  gameDataList:[],
  gameMapDataList:[],
  chatToken:session.getChatToken()
}



// WEBPACK FOOTER //
// ./src/logic/user/state.js